import { render } from "./AdDocViewMyTransactionInAdDocList.vue?vue&type=template&id=4792cfb5&ts=true"
import script from "./AdDocViewMyTransactionInAdDocList.vue?vue&type=script&lang=ts"
export * from "./AdDocViewMyTransactionInAdDocList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__